/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { FC } from 'react';
import { Checkbox, FieldState } from 'informed';
import cn from 'classnames';
import css from './styles.module.scss';

interface ICheckboxField {
  name: string;
  label: string;
  type?: 'default' | 'primary' | 'secondary' | 'white' | 'overlap';
  initialValue?: boolean;
  customClass?: string;
  onChange?:
    | ((fieldState: FieldState, event: React.SyntheticEvent<Element, Event>) => void)
    | undefined;
  disabled?: boolean;
}

const CheckboxField: FC<ICheckboxField> = ({
  name,
  label,
  type = 'default',
  disabled,
  customClass,
  ...rest
}) => (
  <label className={css.wrapper}>
    <Checkbox {...rest} name={name} className={css.input} disabled={disabled} />
    <span
      className={cn(
        css.label,
        {
          [css.default]: type === 'default',
          [css.primary]: type === 'primary',
          [css.secondary]: type === 'secondary',
          [css.white]: type === 'white',
          [css.overlap]: type === 'overlap',
          [css.disabled]: disabled,
        },
        customClass,
      )}
    >
      <span>{label}</span>
    </span>
  </label>
);

export default CheckboxField;
